import required from './required';

const VALIDATIONS = {
  REQUIRED: required,
};

export default VALIDATIONS;
